import { Fragment } from 'react';
import { useQuery } from '../../../services/utils';
import { useHistory } from 'react-router-dom';
import MedicationsForm from './MedicationsForm';
import { Button } from '@mui/material';
import { Box } from '@mui/material';
import AllergiesForm from './AllergiesForm';

interface MedicationsProps {
  apptId: string;
  type: 'New Patient' | 'Follow-up';
  medications: any;
  onContinue: (data?: any, step?: string) => void;
  updateHistory: (history: any) => void;
  continueRef: React.RefObject<HTMLButtonElement>;
  
  // No-Auth
  userId: string;
  token: string;
}

const Medications = (props: MedicationsProps) => {
  const { apptId, type, medications, onContinue, updateHistory, continueRef } = props;
  const { userId, token } = props;

  const history = useHistory();
  const query = useQuery();
  const view = query.get('view') || '1';

  const updateView = (newView: '1' | '2') => {
    const newQueries = new URLSearchParams(query);
    newQueries.set('view', newView);
    history.push(`${window.location.pathname}?${newQueries.toString()}`);
  };

  const internalOnContinue = async () => {
    if (view === '1') {
      updateView('2');
    } else {
      onContinue();
    }
  };

  return (
    <Fragment>
      {view === '1' && (
        <MedicationsForm 
          apptId={apptId} 
          updateHistory={updateHistory}
          type={type}
          onContinue={onContinue}
          userId={userId}
          token={token}
        />
      )}
      {view === '2' && (
        <AllergiesForm 
          apptId={apptId} 
          updateHistory={updateHistory}
          onContinue={onContinue}
          userId={userId}
          token={token}
          allergies={medications?.medicationAllergies || []} 
        />
      )}
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
        <Button 
          variant="contained"
          size="large"
          onClick={internalOnContinue}
          ref={continueRef}
        >
          Continue
        </Button>
      </Box>
    </Fragment>
  );
};

export default Medications;
